import axios from 'axios';

const BUILT_API_URL = process.env.REACT_APP_API_BASE_URL ?? 'http://127.0.0.1:8001/';

/**
 * The API this page should call. On a maintenance bypass host (direct-contractflow.…) the
 * public API sits behind the maintenance page, so the bypass page talks to the bypass API
 * (direct-api.…) instead. See docs/runbooks/maintenance.md in savings-club-k8s.
 */
export const apiUrlFor = (pageHost: string, builtApiUrl: string): string =>
  pageHost.startsWith('direct-') ? builtApiUrl.replace('://', '://direct-') : builtApiUrl;

export const API_URL = apiUrlFor(window.location.host, BUILT_API_URL);

/**
 * Who links bank accounts: Stripe Financial Connections, or Plaid.
 *
 * Stripe removes legacy ACH Direct Debit on 2026-08-21 and Plaid links land on that legacy
 * path, so 'stripe' is the default. Plaid stays fully wired — set this to 'plaid' to roll
 * the whole ACH flow back without a code change. Read the environment variable only here.
 */
export const BANK_LINK_PROVIDER =
  process.env.REACT_APP_BANK_LINK_PROVIDER === 'plaid' ? 'plaid' : 'stripe';

export const isPlaidBankLink = BANK_LINK_PROVIDER === 'plaid';

export const axiosInstance = axios.create({
  baseURL: `${API_URL}api/`,
  // Signing a multi-seat contract is the longest request we make, and giving up before the
  // server does is what leaves a customer charged but told the contract was not signed.
  // 90s is the ceiling worth waiting for: Cloudflare cuts origin responses off at 100s.
  timeout: 90000,
});
